export const objectsOfValueQuotes = {
  columnParams: 'grid-cols-[1fr,1fr,1fr,1fr,1fr,1fr]',
  columns: [
    [
      { id: 'date', type: 'date', textAlign: 'text-left' },
      { id: 'source', type: 'string', classNamesBoth: 'sm:hidden' },
    ],
    [{ id: 'source', type: 'string', classNamesBoth: 'hidden sm:block', textAlign: 'text-center' }],
    [{ id: 'quoteBaseCurrency', usesHeader: 'price', type: 'currency0Decimals' }], // usesHeader: if found, the header and tooltip will use this element from the i18n file
    [{ id: 'currency', type: 'string', classNamesBoth: 'hidden sm:block' }],
    [
      { id: 'quote', usesHeader: 'originalPrice', type: 'number0Decimals' },
      { id: 'currency', type: 'string', classNamesBoth: 'sm:hidden' },
    ],
    [{ id: 'note', type: 'string' }],
  ],
};

export const objectsOfValueTransactions = {
  columnParams: 'grid-cols-[1fr,minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),3rem]',
  columns: [
    [
      { ifSummaryRowDisplay: false, id: 'date', type: 'date', textAlign: 'text-left', classNamesBoth: 'text-xs sm:text-sm' },
      { ifSummaryRowDisplay: true, id: 'displayName', type: 'string', textAlign: 'text-left', classNamesBoth: 'text-xs sm:text-sm', ifSummaryRowclassNames: 'text-brandBlue-600' },
    ],
    [{ id: 'purchaseValue', type: 'currency0Decimals', classNamesBody: 'text-xs sm:text-sm' }],
    [{ id: 'currentValue', type: 'currency0Decimals', classNamesBody: 'text-xs sm:text-sm' }],
    [
      { id: 'dividendsSincePurchase', usesHeader: 'proceeds', type: 'currency', classNamesBody: 'text-xs sm:text-sm' },
      { id: 'fees', usesHeader: 'costs', type: 'currency', classNamesBody: 'text-xs sm:text-sm' },
    ],
    [
      { id: 'roi', type: 'percentage', usesHeader: 'roiOnly', classNamesBody: 'text-xs sm:text-sm' },
      { id: 'roiAnnual', type: 'percentage', classNamesBody: 'text-xs text-gray-400' },
    ],
    [{ id: 'ellipsis', type: 'ellipsis', usesHeader: 'emptyString', classNamesBody: '-ml-3' }],
  ],
};
